import React, { useState } from 'react';

const Sachets = ({ product, updateProduct }) => {
  const [selectedMaterial, setSelectedMaterial] = useState(product.fields.material || '');
  const [customMaterial, setCustomMaterial] = useState('');

  // Material options
  const materialOptions = [
    "PET / VMPET / PE",
    "PET / PE",
    "MATTE OPP / VMPET / PE",
    "PET / AL / PE",
    "PET / LDPE",
    "ALOX",
    "KRAFT PAPER / PE",
    "KRAFT PAPER / VMPET / PE",
    "PE / PE",
    "KRAFT PAPER / PLA",
    "MATTE OPP / PET / PE",
    "Other"
  ];

  // Special finishes options
  const specialFinishes = [
    "Gloss Lamination",
    "Matte Lamination",
    "Gloss Varnish",
    "Matte Varnish",
    "Soft Touch",
    "Hologram Lamination"
  ];

  // Handle material change
  const handleMaterialChange = (e) => {
    const material = e.target.value;
    setSelectedMaterial(material);
    
    if (material === 'Other') {
      updateProduct('material', '');
    } else {
      updateProduct('material', material);
      setCustomMaterial('');
    }
  };

  // Handle custom material input
  const handleCustomMaterialChange = (e) => {
    const value = e.target.value;
    setCustomMaterial(value);
    updateProduct('material', value);
  };

  // Handle special finish change
  const handleSpecialFinishChange = (finish) => {
    let currentFinishes = product.fields.specialFinishes || [];
    if (currentFinishes.includes(finish)) {
      currentFinishes = currentFinishes.filter(f => f !== finish);
    } else {
      currentFinishes.push(finish);
    }
    updateProduct('specialFinishes', currentFinishes);
  };

  return (
    <div className="product-form">
      {/* Material */}
      <div className="form-group">
        <label className="block tracking-wide text-sm font-bold leading-6 text-gray-900">Material:</label>
        <select
          className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg"
          value={selectedMaterial}
          onChange={handleMaterialChange}
        >
          <option value="">Select Material</option>
          {materialOptions.map((material, index) => (
            <option key={index} value={material}>{material}</option>
          ))}
        </select>
        
        {selectedMaterial === 'Other' && (
          <div className="mt-2">
            <input
              type="text"
              className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg w-full p-2.5"
              value={customMaterial}
              onChange={handleCustomMaterialChange}
              placeholder="Enter custom material"
            />
          </div>
        )}
      </div>

      {/* Special Finishes */}
      <div className="form-group">
        <label className="block tracking-wide text-sm font-bold leading-6 text-gray-900">Special Finishes:</label>
        <div className="grid gap-2 grid-cols-2">
          {specialFinishes.map((finish) => (
            <label key={finish} className="flex items-center">
              <input
                type="checkbox"
                checked={product.fields.specialFinishes?.includes(finish) || false}
                onChange={() => handleSpecialFinishChange(finish)}
                className="mr-2"
              />
              {finish}
            </label>
          ))}
        </div>
      </div>

      {/* Thickness */}
      <div className="form-group">
        <label className="block tracking-wide text-sm font-bold leading-6 text-gray-900">Thickness (in microns):</label>
        <input
          type="number"
          className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg"
          value={product.fields.thickness || ''}
          onChange={(e) => updateProduct('thickness', e.target.value)}
          min="1"
        />
      </div>

      {/* Size */}
      <div className="form-group">
        <label className="block tracking-wide text-sm font-bold leading-6 text-gray-900">Size:</label>
        <div className="grid grid-cols-2 gap-4">
          <div>
            <label className="block text-sm text-gray-600">Width (mm):</label>
            <input
              type="number"
              className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg w-full"
              value={product.fields.size?.widthMM || ''}
              onChange={(e) => {
                const size = { ...product.fields.size, widthMM: e.target.value };
                updateProduct('size', size);
              }}
              min="1"
            />
          </div>
          <div>
            <label className="block text-sm text-gray-600">Height (mm):</label>
            <input
              type="number"
              className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg w-full"
              value={product.fields.size?.heightMM || ''}
              onChange={(e) => {
                const size = { ...product.fields.size, heightMM: e.target.value };
                updateProduct('size', size);
              }}
              min="1"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Sachets;
